import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn } from 'typeorm'

@Entity("go2cardless_webhook")
export class Go2CardlessWebhook {
    
    @PrimaryGeneratedColumn({ name: "id" })
    id?: number

    @Column()
    url?: string

    @CreateDateColumn()
    createdAt?: Date

    @UpdateDateColumn()
    updatedAt?: Date
}